export default {
  SET_ALL_DATAS: (state, data) => (state.datas = data),
};
